import React from "react";

// React hook formで使用するバリデータの定義を定数化

export const ErrorInfo = (props: {
  error?: { type: string; message?: string };
  name?: string;
}) => {
  const { error } = props;
  return error ? (
    <dd className="errmsg">{error.message || "入力エラーです。"}</dd>
  ) : (
    <></>
  );
};

export const required = { value: true, message: "入力してください。" };

// REGEXP系定義
export const phoneRegexp = {
  value: /^0[56789]0[0-9]{8}$/,
  message: "携帯電話番号の形式で入力してください。",
};
export const emailRegexp = {
  value: /^[^@]+@[^@]+$/,
  message: "メールアドレスの形式で入力してください。",
};

const ALPHA = "\u{0061}-\u{007a}\u{0041}-\u{005a}";
const HIRA = "\u{3041}-\u{3093}\u{309B}-\u{309E}";
const KATA = "\u{30A1}-\u{30F6}\u{30FB}-\u{30FE}";
// CJK 統合漢字+拡張A~D
const CJK = "\u{4E00}-\u{9FFC}";
const CJK_EXT_A = "\u{3400}-\u{4DBF}";
const CJK_EXT_B = "\u{20000}-\u{2A6DD}";
const CJK_EXT_C = "\u{2A700}-\u{2B734}";
const CJK_EXT_D = "\u{2B740}-\u{2B81D}";
const KANJI = `${CJK}${CJK_EXT_A}${CJK_EXT_B}${CJK_EXT_C}${CJK_EXT_D}`;

export const shimeiRegexp = {
  value: new RegExp(`^[${ALPHA}${HIRA}${KATA}${KANJI}]*$`, "mu"),
  message: "入力禁止文字が含まれています。",
};

export const zenKanaOnly = {
  value: /^[\u30A0-\u30FF ]*$/,
  message: "全角カナで入力してください。"
}

export const maxLength = (maxLength: number) => {
  return {
    maxLength: {
      value: maxLength,
      message: `最大文字数(${maxLength})を超えています。`,
    },
  };
};
